import { useState } from "react";
import { TOPIC_CATEGORIES } from "../../constants/community";

export default function TopicComposer({ onSubmit, onCancel, submitting }) {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [category, setCategory] = useState("general");

  async function handleSubmit(e) {
    e.preventDefault();
    if (!title.trim() || title.trim().length < 3) return;
    await onSubmit(title.trim(), body.trim(), category);
  }

  return (
    <div className="topic-composer-overlay" onClick={onCancel}>
      <div className="topic-composer" onClick={e => e.stopPropagation()}>
        <div className="topic-composer-header">
          <h3>Tạo chủ đề mới</h3>
          <button className="topic-composer-close" onClick={onCancel}>✕</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="topic-composer-field">
            <label>Danh mục</label>
            <div className="topic-composer-categories">
              {TOPIC_CATEGORIES.map(cat => (
                <button
                  key={cat.id}
                  type="button"
                  className={`topic-filter-btn ${category === cat.id ? "active" : ""}`}
                  onClick={() => setCategory(cat.id)}
                >
                  {cat.emoji} {cat.label}
                </button>
              ))}
            </div>
          </div>

          <div className="topic-composer-field">
            <label>Tiêu đề <span className="char-count">{title.length}/200</span></label>
            <input
              type="text"
              className="topic-composer-input"
              value={title}
              onChange={e => setTitle(e.target.value)}
              placeholder="Tiêu đề chủ đề..."
              maxLength={200}
              autoFocus
            />
          </div>

          <div className="topic-composer-field">
            <label>Nội dung <span className="char-count">{body.length}/2000</span></label>
            <textarea
              className="topic-composer-textarea"
              value={body}
              onChange={e => setBody(e.target.value)}
              placeholder="Chia sẻ suy nghĩ của bạn... (không bắt buộc)"
              maxLength={2000}
              rows={5}
            />
          </div>

          <div className="topic-composer-actions">
            <button
              type="button"
              className="topic-composer-cancel"
              onClick={onCancel}
            >
              Hủy
            </button>
            <button
              type="submit"
              className="topic-composer-submit"
              disabled={title.trim().length < 3 || submitting}
            >
              {submitting ? "Đang tạo..." : "Đăng chủ đề"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
